"use strict";
/**
 * @module diffusion.topicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateConstraintOperator = void 0;
/**
 * An operator used in a constraint comparison.
 *
 * Accessible through `diffusion.topicUpdate.UpdateConstraintOperator`
 *
 * @since 6.10
 */
var UpdateConstraintOperator;
(function (UpdateConstraintOperator) {
    /**
     * Strict binary equality.
     *
     * This operator requires that the binary topic value is exactly
     * equivalent to the value supplied for comparison.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["IS"] = 1] = "IS";
    /**
     * Lenient equals.
     *
     * This operator requires that the topic value is logically equal to the
     * supplied value.
     *
     * If the supplied value is a string the string representation of the
     * specified topic value is compared for string equality.
     *
     * If the supplied value is a number ({@link DataTypes.int64 Int64} or {@link DataTypes.double Double})
     * the corresponding topic value may be a number or a string containing
     * a parseable number and will be compared for numeric equality.
     *
     * If the supplied value is null the condition will be satisfied if the
     * value at a specified pointer is JSON null.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["EQ"] = 2] = "EQ";
    /**
     * Lenient not equals.
     *
     * This operator requires that the topic value is logically not equal to
     * the supplied value.
     *
     * If the supplied value is a string the string representation of the
     * specified topic value is compared for string equality.
     *
     * If the supplied value is a number ({@link DataTypes.int64 Int64} or {@link DataTypes.double Double})
     * the corresponding topic value may be a number or a string containing
     * a parseable number and will be compared for numeric equality.
     *
     * If the supplied value is null the condition will be satisfied if the
     * value at a specified pointer not JSON null.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["NE"] = 3] = "NE";
    /**
     * Lenient greater than.
     *
     * This operator requires that the topic value is greater than the
     * supplied value.
     *
     * The supplied value must be a number ({@link DataTypes.int64 Int64} or {@link DataTypes.double Double}).
     * The corresponding topic value may be a number or a string containing
     * a parseable number and the condition will be satisfied if the topic
     * value is greater than the supplied value.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["GT"] = 4] = "GT";
    /**
     * Lenient greater than or equals.
     *
     * This operator requires that the topic value is greater than or equal
     * to the supplied value.
     *
     * The supplied value must be a number ({@link DataTypes.int64 Int64} or {@link DataTypes.double Double}).
     * The corresponding topic value may be a number or a string containing
     * a parseable number and the condition will be satisfied if the topic
     * value is greater than or equal to the supplied value.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["GE"] = 5] = "GE";
    /**
     * Lenient less than.
     *
     * This operator requires that the topic value is less than the supplied
     * value.
     *
     * The supplied value must be a number ({@link DataTypes.int64 Int64} or {@link DataTypes.double Double}).
     * The corresponding topic value may be a number or a string containing
     * a parseable number and the condition will be satisfied if the topic
     * value is less than the supplied value.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["LT"] = 6] = "LT";
    /**
     * Lenient less than or equals.
     *
     * This operator requires that the topic value is less than or equal to
     * the supplied value.
     *
     * The supplied value must be a number ({@link DataTypes.int64 Int64} or {@link DataTypes.double Double}).
     * The corresponding topic value may be a number or a string containing
     * a parseable number and the condition will be satisfied if the topic
     * value is less than or equal to the supplied value.
     */
    UpdateConstraintOperator[UpdateConstraintOperator["LE"] = 7] = "LE";
})(UpdateConstraintOperator = exports.UpdateConstraintOperator || (exports.UpdateConstraintOperator = {}));
